import { useState, useCallback } from 'react';

export interface ButtonState {
  isLoading: boolean;
  isSuccess: boolean;
  buttonText: string;
}

export const useButtonState = (
  defaultText: string,
  loadingText: string = `${defaultText}ing...`,
  successText: string = `${defaultText}ed ✅`
) => {
  const [state, setState] = useState<ButtonState>({
    isLoading: false,
    isSuccess: false,
    buttonText: defaultText
  });

  const startLoading = useCallback(() => {
    setState({
      isLoading: true,
      isSuccess: false,
      buttonText: loadingText
    });
  }, [loadingText]);

  const showSuccess = useCallback((duration: number = 2000) => {
    setState({
      isLoading: false,
      isSuccess: true,
      buttonText: successText
    });

    // Reset to default after duration
    setTimeout(() => {
      setState({
        isLoading: false,
        isSuccess: false,
        buttonText: defaultText
      });
    }, duration);
  }, [defaultText, successText]);

  const reset = useCallback(() => {
    setState({
      isLoading: false,
      isSuccess: false,
      buttonText: defaultText
    });
  }, [defaultText]);

  return {
    ...state,
    startLoading,
    showSuccess,
    reset
  };
};

